import React, { Component } from 'react';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class EmailInstructionsDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel } = this.props;

        return {
            header: t('EmailInfrastructureSetup_Title'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { records, t } = this.props;
     
        const spfDescriptionExistingRecord = t('EmailInfrastructureSetup_Spf_DescriptionExistingRecord', { address: records && records.spfIncludeAddress });
        const dkimDescription = t('EmailInfrastructureSetup_Dkim_Description', { selector: records && records.dkimSelector });

        return <div class="modal-body">
            <p> {t('EmailInfrastructureSetup_Description')}</p>
            <h4>{t('EmailInfrastructureSetup_Spf_Title')}</h4>
            <p dangerouslySetInnerHTML={{ __html: t('EmailInfrastructureSetup_Spf_Description') }}/>
            <pre>{records && records.spfRecord}</pre>
            <p dangerouslySetInnerHTML={{ __html: spfDescriptionExistingRecord }} />
            <h4>{t('EmailInfrastructureSetup_Dkim_Title')}</h4>
            <p dangerouslySetInnerHTML={{ __html: dkimDescription }}/>
            <pre>{records && records.dkimRecord}</pre>
            <p dangerouslySetInnerHTML={{ __html: t('EmailInfrastructureSetup_Dkim_DescriptionEscapedRecord') }}/>
            <pre>{records && records.dkimRecordEscaped}</pre>
        </div>;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;

        return [closeBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock = {unblock} />;
    }
}
export default withTranslation()(EmailInstructionsDialog);